function initConceptoraComparison(section) {
  section._conceptoraAbort?.abort();
  const controller = new AbortController();
  section._conceptoraAbort = controller;
  const tabs = [...section.querySelectorAll('[role="tab"]')];
  const panels = [...section.querySelectorAll('[role="tabpanel"]')];
  if (!tabs.length) return;

  const activate = (tab, focus = false) => {
    tabs.forEach((item) => {
      const active = item === tab;
      item.setAttribute('aria-selected', String(active));
      item.tabIndex = active ? 0 : -1;
    });
    panels.forEach((panel) => { panel.hidden = panel.id !== tab.getAttribute('aria-controls'); });
    if (focus) tab.focus();
  };

  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => activate(tab), { signal: controller.signal });
    tab.addEventListener('keydown', (event) => {
      let nextIndex;
      if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
      if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = tabs.length - 1;
      if (nextIndex === undefined) return;
      event.preventDefault();
      activate(tabs[nextIndex], true);
    }, { signal: controller.signal });
  });
  activate(tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') || tabs[0]);
}

document.querySelectorAll('[data-conceptora-comparison]').forEach(initConceptoraComparison);
if (!window.__conceptoraComparisonEditorListener) {
  window.__conceptoraComparisonEditorListener = true;
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-conceptora-comparison]').forEach(initConceptoraComparison);
  });
}
